import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  IconButton,
  Typography,
  Grid,
  Paper,
  Button
} from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import LambdaFetch from '../functions/FetchFromLambda'
import LoadingButton from '../components/LoadingButton'
import {
  journalControlCols,
  journalControlCommentCols
} from '../constants/GlCols'
import { smallScreenWidth } from '../constants/AppConstants'
import OpenSearchDropdown from '../components/OpenSearchDropdown'
import HardCodedDropdown from '../components/HardCodedDropdown'
import { DashboardAthenaTable } from '../components/DashboardAthenaTable'
import fetchFromAthena from '../functions/FetchFromAthena'
import DialogTable from '../components/DialogTable'
import LoadingLink from '../components/LoadingLink'
const _ = require('lodash')

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    margin: '2rem 1rem'
  },
  treeRoot: {
    flexGrow: 1,
    margin: '1rem'
  }
}))

const defaultHeaders = {
  fiscalYear: '',
  acctPeriod: '',
  company: ''
}

export default function GlTransServerSideV2(props) {
  const [state, setstate] = useState({
    options: null,
    isLoading: false,
    data: null,
    fetched: true,
    isServerSide: false
  })
  const [comments,setComments]= useState(null)
  const [showTable, setShowTable] = useState(false)
  const [headers, setHeaders] = useState(defaultHeaders)
  const [clearHeader, setClearHeaders] = React.useState(false)
  const [tableKey, setTableKey] = useState(JSON.stringify(defaultHeaders))
  const [clearTrigger, setClearTrigger] = useState(false)

  const classes = useStyles()

  const { credentials } = props.fetchInitialData

  const getAttachment = async objId => {

    const data = await fetchFromAthena({
          queryName: 'jc_attach_read',
          headers: {
            index_name: objId,
          },
          accessToken: credentials.user.accessToken,
                credentials: credentials
        })
        console.log(data)

        setComments(data)
  }
  const handleSubmit = e => {
    e.preventDefault()
    if (JSON.stringify(headers) === state.tableKey) return null
    setShowTable(true)
    setstate({ ...state, isLoading: true, tableKey: JSON.stringify(headers) })
  }

  const handleCallback = (values, error) => {
    if (error) {
      setstate({ ...state, isLoading: false })
      setShowTable(false)
      return null
    }
    setstate({ ...state, isLoading: false })
  }

  const tableDataTransformation = rows => {
    if (!rows) return []
    return rows.map(row => {
      return {
        ...row,
        VIEW: row.LINK ? (
          <LoadingLink
            className="editLink"
            onClick={async() => {
              await getAttachment(row.LINK)
            }}
          >
            view
          </LoadingLink>
        ) : ''
      }
    })
  }

  return (
    <div style={{ padding: '1.5rem 0.5rem' }}>

      <DialogTable
              isOpen={!!comments}
              handleClose={() => setComments(null)}
              tableData={comments}
              cols={journalControlCommentCols}
              noFooter
        simpleTable={true}
            />

      <IconButton
        style={{ borderRadius: '5px', position: 'absolute' }}
        size='small'
        onClick={() => props.history.push('/')}
        aria-label='back'
      >
        <ArrowBackIcon />
        {props.fetchInitialData.credentials.appWidth > smallScreenWidth &&
          'Dashboard'}
      </IconButton>
      <Typography variant='h5' style={{ textAlign: 'center' }}>
        Journal Control (GL45)
      </Typography>
      <div className={classes.root}>
        <Paper elevation={0} style={{ padding: '1rem' }}>
          <form onSubmit={handleSubmit}>
            <Grid
              container
              alignContent='center'
              alignItems='flex-start'
              spacing={3}
            >
              <Grid item>
                <OpenSearchDropdown
                  id='company'
                  required
                  width='125px'
                  label='Company'
                  page="GLTRANS"
                  entity="COMPANY"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  variant='standard'
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    const companyValue = val?.VALUE || ''
                    setHeaders({ ...headers, company: companyValue })
                  }}
                />
              </Grid>
              <Grid item>
                <OpenSearchDropdown
                  id='fiscalYear'
                  required
                  width='125px'
                  label='Year'
                  page="GLJOURNAL"
                  entity="YEAR"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  variant='standard'
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    const fiscalYearValue = val?.VALUE || ''
                    setHeaders({ ...headers, fiscalYear: fiscalYearValue })
                  }}
                />
              </Grid>
              <Grid item>
                <HardCodedDropdown
                  id='acctPeriod'
                  required
                  width='125px'
                  label='Period'
                  dataset="PERIOD"
                  variant='standard'
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    const acctPeriodValue = val?.VALUE || ''
                    setHeaders({ ...headers, acctPeriod: acctPeriodValue })
                  }}
                />
              </Grid>
            </Grid>

            <div style={{ marginTop: '1rem' }}>
              <LoadingButton
                label='Submit'
                disabled={!(headers.fiscalYear && headers.acctPeriod)}
                isLoading={state.isLoading}
                color='primaryVLButton'
                buttonType='submit'
              />
              {!!(
                headers.company ||
                headers.fiscalYear ||
                headers.acctPeriod
              ) && (
                <Button
                  onClick={() => {
                    setClearHeaders(!clearHeader)
                    setHeaders(defaultHeaders)
                    setShowTable(false)
                    setClearTrigger(prev => !prev)
                  }}
                  style={{ marginLeft: '0.5rem' }}
                >
                  Clear
                </Button>
              )}
            </div>
          </form>
        </Paper>
        {showTable && (
          <div style={{ marginTop: '1rem ' }}>
            <DashboardAthenaTable
              {...props}
              isTempTable={true}
              key={state.tableKey}
              params={{ ...headers }}
              tableColumns={journalControlCols}
              reportParamName="journal_control"
              reportName='journal_control_temp'
              tableTitle={''}
              callback={handleCallback}
              transform={tableDataTransformation}
              downloadFileName={'Journal_Control_Download'}
            />

          </div>
        )}
      </div>
    </div>
  )
}
